//https://angular.io/guide/dynamic-component-loader
import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[lmsContentItemHost]',
    standalone: true
})
export class LmsContentItemDirective {
   constructor(public viewContainerRef: ViewContainerRef) {
      //console.log('constructor:content item directive');
   }
}
